import { Link } from "react-router-dom";
import { House } from "lucide-react";

export default function Brand({ to = "/", compact = false }) {
  return (
    <Link to={to} className="brand" aria-label="Highlander Homes home">
      <span className="brand-mark">
        <House size={23} strokeWidth={1.6} />
      </span>
      <span>
        Highlander
        <span className={compact ? "brand-sub compact" : "brand-sub"}>
          HOMES
        </span>
      </span>
    </Link>
  );
}
